import React from 'react';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  ParagraphText,
  UtilityText,
  HeadingText,
  TextAction,
} from '@leagueplatform/genesis-core';

export function RemoveServiceWarningModal(props: any) {
  const { onClose } = props;

  return (
    <Modal.Root>
      <Modal.Trigger>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              position: 'relative',
              marginBottom: '$two',
            } as GDSStyleObject
          }
        >
          <TextAction
            size={{
              '@initial': 'large',
              '@mobile': 'medium',
              '@tablet': 'large',
            }}
            as="button"
          >
            Remove This Service
          </TextAction>
        </Box>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        width={{ '@initial': 650, '@mobile': '100%' }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <StackLayout
          css={{ textAlign: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              Are you sure you want to remove this service?
            </HeadingText>
          </Modal.Title>
          <ParagraphText emphasis="subtle">
            The selected service will be removed and will no longer be available
            for viewing.
          </ParagraphText>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'row',
                padding: '$two $four $one $four',
                justifyContent: 'space-around',
              } as GDSStyleObject
            }
          >
            <Modal.Close>
              <UtilityText
                css={{
                  color: '#0074C9',
                  cursor: 'pointer',
                }}
              >
                No
              </UtilityText>
            </Modal.Close>
            <Modal.Close>
              <UtilityText
                css={{
                  color: '#0074C9',
                  cursor: 'pointer',
                }}
                onClick={onClose}
              >
                Yes
              </UtilityText>
            </Modal.Close>
          </Box>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
}
